import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from 'ui-elements/button';
import { fadeInOut } from 'common';
import { RouterLink } from '@angular/router';
import { select, Store } from '@ngxs/store';
import {
  ShellState,
  UserPrefState,
  SetDismissPromoBanner,
} from '../../shell.state';
import { PageSelectors } from '../../../page/state/page.selectors';

@Component({
  selector: 'ss-www-promo-banner',
  imports: [CommonModule, ButtonComponent, RouterLink],
  templateUrl: './promo-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInOut],
})
export class PromoBannerComponent {
  private store = inject(Store);
  page = select(PageSelectors.page);
  url = computed(() => this.page()?.url);
  disabledRoutes = ['/conservatory'];
  headerContent$ = this.store.select(ShellState.headerContent);
  isBannerVisible$ = this.store.select(UserPrefState.isPromoBannerVisible);
  isDisabledRoute = computed(() =>
    this.disabledRoutes.some((route) => this.url()?.startsWith(route))
  );
  dispatchSetDismissPromoBanner() {
    this.store.dispatch(new SetDismissPromoBanner());
  }
}
